import React from 'react';

import '../assets/scss/contributor.scss';

const LinkedComponent = ({ link, className, children }) => {
    return 'url' in link ? <a href={link.url} target={link.target} className={className}>{children}</a> : children;
};

const Contributor = (props) => {
    const { id, name, description, link, image } = props;

    return (
        <div id={id} className="contributor">
            <LinkedComponent link={link} className="contributor__name">
                {name[0].text}
            </LinkedComponent>

            {description && !!description.length && (
                <p className="contributor__description">
                    {description[0].text}
                </p>
            )}

            {'url' in link && (
                <a
                    href={link.url}
                    target={link.target}
                    className="contributor__link"
                >
                    {link.url}
                </a>
            )}

            {image && (
                <LinkedComponent link={link} className={null}>
                    <img
                        src={image.url}
                        alt={image.alt ? image.alt : ''}
                        loading="lazy"
                        className="contributor__image"
                    />
                </LinkedComponent>
            )}
        </div>
    )
};
export default Contributor;